import modalTemplate from './view.html';
import { ReactModalController } from './controller';

class ReactModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (params = null, size='lg') => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: ReactModalController,
            controllerAs: '$',
            size: size,
            resolve: {
                params: params,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    ReactModal,
    ReactModalController,
};
